module.exports = __webpack_public_path__ + "static/media/arrow-circle-right.c472f9b1.svg";